import React, { useState } from "react";
import axios from "axios";
import "./Contact.css";

function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  // Gérer la soumission du formulaire
  const handleSubmit = (e) => {
    e.preventDefault();
    axios
      .post("http://localhost:5000/api/messages", formData)
      .then(() => {
        alert("Message envoyé avec succès !");
        setFormData({ name: "", email: "", message: "" });
      })
      .catch((error) => {
        console.error("Erreur lors de l'envoi du message :", error);
      });
  };

  // Gérer les changements dans le formulaire
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <div className="contact-container">
      {/* Partie 1 : Informations de contact */}
      <div className="contact-info">
        <h2>Me Contacter</h2>
        <p>
          <i className="fas fa-phone-alt"></i> Téléphone : +225 01 23 45 67 89
        </p>
        <p>
          <i className="fas fa-map-marker-alt"></i> Localisation : Abidjan, Côte
          d'Ivoire
        </p>
        <p>
          <i className="fas fa-envelope"></i> Email :
          joseph.kouakou@example.com
        </p>
      </div>

      {/* Partie 2 : Formulaire de contact */}
      <div className="contact-form-container">
        <h2>M'écrire</h2>
        <form onSubmit={handleSubmit} className="contact-form">
          <input
            type="text"
            name="name"
            placeholder="Nom"
            value={formData.name}
            onChange={handleChange}
            required
          />
          <input
            type="email"
            name="email"
            placeholder="Email"
            value={formData.email}
            onChange={handleChange}
            required
          />
          <textarea
            name="message"
            placeholder="Message"
            value={formData.message}
            onChange={handleChange}
            required
          ></textarea>
          <button type="submit">Envoyer</button>
        </form>
      </div>
    </div>
  );
}

export default Contact;
